import { useLocation } from "react-router-dom";

const useRoutePermission = ({ user }) => {
  const location = useLocation();
  const { pathname } = location;

  const pathOrigin = pathname.replace(/^\//, "").toLowerCase();

  let isAllowed = null;
  let isMarketWatch = null;

  if (Object.keys(user).length === 0) {
    isAllowed = false;
  } else {
    const routePermissions = user?.pages.split(",");

    //check if not admin and has route permission of market watch send flag for marketContext
    if (user?.role.toLowerCase() !== "admin") {
      isMarketWatch = routePermissions.some(
        (route) => route.toLowerCase() === "marketwatch"
      );
    }

    const routesAllUsers = [
      "dashboard",
      "twofactorauth",
      "changepassword",
      "loginhistory",
    ];

    if (routesAllUsers.includes(pathOrigin)) {
      isAllowed = true;
    } else {
      if (user?.role.toLowerCase() === "admin") {
        isAllowed = true;
        isMarketWatch = true;
      } else {
        isAllowed = routePermissions.some(
          (route) => route.toLowerCase() === pathOrigin
        );
      }
    }
  }

  return {
    isAllowed,
    isMarketWatch,
  };
};

export default useRoutePermission;
